import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Home from "@/pages/Home";
import Program from "@/pages/Program";
import Search from "@/pages/Search";
import Admin from "@/pages/Admin";
import { AuthProvider } from "@/lib/auth";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Header />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/programs/:id" element={<Program />} />
                        <Route path="/search" element={<Search />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                    <footer className="mt-16 border-t border-zinc-200 bg-zinc-50 py-8">
                        <div className="mx-auto max-w-7xl px-6 md:px-12">
                            <div className="pp-overline">
                                Rødt Program-arkivet: En tjeneste fra Rødt Bergen
                            </div>
                        </div>
                    </footer>
                    <Toaster />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
